<script setup lang="ts">
const props = defineProps<{
  erid?: string | null;
  company?: string | null;
}>();

const isOpen = ref(false);
const isCopied = ref(false);

function toggle(e: Event) {
  e.stopPropagation();
  e.preventDefault();
  isOpen.value = !isOpen.value;
}

function close(e: Event) {
  e.stopPropagation();
  e.preventDefault();
  isOpen.value = false;
}

async function copyToken(e: Event) {
  e.stopPropagation();
  e.preventDefault();
  if (!props.erid) {
    return;
  }
  try {
    await navigator.clipboard.writeText(props.erid);
  } catch {
    const textarea = document.createElement('textarea');
    textarea.value = props.erid;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
  isCopied.value = true;
  setTimeout(() => {
    isCopied.value = false;
  }, 2000);
}
</script>

<template>
  <template v-if="erid">
    <span :class="$style.trigger" role="button" @click="toggle"> Реклама</span>

    <div v-if="isOpen" :class="$style.overlay" @click.stop.prevent>
      <p v-if="company" :class="$style.advertiser">{{ company }}</p>
      <button :class="$style.copyBtn" @click="copyToken">
        {{ isCopied ? 'Скопировано' : 'Скопировать токен' }}
      </button>
      <button :class="$style.close" @click="close">Закрыть</button>
    </div>
  </template>
</template>

<style module lang="scss">
.trigger {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 1px;
  color: var(--color-gray-text);
  text-align: right;
  cursor: pointer;
  user-select: none;
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 15px 21px;
  background-color: var(--color-white);
  border-radius: 6px;
  z-index: 1;
}

.advertiser {
  margin: 0;
  width: 163px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 1px;
  color: var(--color-gray-text);
}

.copyBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 163px;
  height: 40px;
  margin-top: auto;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-line);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--color-black-1);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: var(--color-gray-bg);
  }
}

.close {
  position: absolute;
  bottom: 6px;
  right: var(--space-2-5x);
  padding: 0;
  background: none;
  border: none;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 1px;
  color: var(--color-gray-text);
  text-align: right;
  cursor: pointer;
}
</style>
